export default (k, m) => m[k] || m.default
